import { render } from "./orderManage.vue?vue&type=template&id=0bf38260&scoped=true"
import script from "./orderManage.vue?vue&type=script&lang=js"
export * from "./orderManage.vue?vue&type=script&lang=js"

import "./orderManage.vue?vue&type=style&index=0&id=0bf38260&scoped=true&lang=css"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf38260"]])

export default __exports__